import React, { useState, useEffect } from "react";
import DivisionTableComponent from "./DivisionTableComponent";
import CoachingInsights from "./CoachingInsightComponent";
import GraphComponent from "./GraphComponent";
import { useRef } from "react";
import LoadingButtonComponent from "../LoadingButtonComponent";
import { getFinancialDateRange, groupAreaDivisionProgramSummary, makeDownloadPdf } from "../utils";
import ModalLoadingScreen from "../ModalLoadingScreen";
import DuplicateRecordTable from "../DuplicateRecordTable";
import { useSearchParams } from "react-router-dom";

export default (({ onClose, referralData = {}, loading = false, formData, coachingInsight, isPrint = false, historyData = {} }) => {
    const mainRef = useRef(null);
    const [programWise, setProgramWise] = useState([]);
    const [total, setTotal] = useState('');
    const [clinicWise, setClinicWise] = useState([]);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [showDuplicate, setShowDuplicate] = useState(false);
    const [searchParams] = useSearchParams();
    const duplicate = searchParams.get("duplicate");

    useEffect(() => {
        setProgramWise(referralData?.clinicData?.divisions?.programWise || []);
        setTotal(referralData?.clinicData?.divisions?.total || '');
        setClinicWise(referralData?.clinicData?.divisions?.clinicWise || []);
    }, [referralData]);

    const handleDownloadPdf = async () => {
        setDownloadLoading(true);
        try {
            await makeDownloadPdf({ referralData, formData, coachingInsight }, '#fffbec', 'divisional-report');

            // await generatePDF(mainRef, 'divison-report', "/report/bg.png", '#fffbec');
            // await storeReport(historyData);
            // await DownloadPdf(mainRef, {
            //     backgroundImage: "/report/bg.png",  // ✅ Pass URL directly
            //     backgroundColor: '#fffbec'
            // });
        } catch (err) {
            console.error(err);
        } finally {
            setDownloadLoading(false);
        }
    };
    // const {areaWise,clinicWise,programWise,total}= groupAreaDivisionProgramSummary(referralData);
// console.log(areaWise,clinicWise,programWise,total);
    if (loading || referralData.length < 1) {
        return <ModalLoadingScreen loading={loading} title="Divisional Report" onClose={() => onClose(false)} />
    }


    return <>
        <div className="modal-header">
            <div className="d-flex justify-content-between w-full align-items-center">
                <h5 className="modal-title">
                    Divisional Report
                </h5>
                <div className="pe-6 ">
                    <LoadingButtonComponent
                        disabled={downloadLoading}
                        onClick={handleDownloadPdf}
                        type="button" className="btn btn-sm btn-info text-white "
                        title="Download PDF"
                        loadingTitle="Generating PDF..."
                        loading={downloadLoading}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-download h-4 w-4 mt-1"
                            data-lov-id="src\components\ReportsTab.tsx:384:18">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" x2="12" y1="15" y2="3"></line>
                        </svg>
                    </LoadingButtonComponent>
                    {
                        duplicate &&
                        <button className="btn btn-sm btn-light ms-2" type="button" onClick={() => setShowDuplicate(!showDuplicate)}>
                            {showDuplicate ? 'Hide ' : 'Show '} Duplicate
                        </button>
                    }
                </div>


            </div>
            <button type="button" className="btn-close" onClick={() => onClose(false)}></button>
        </div>

        {/* <td rowSpan={group.programs.length}
                                        className="tdRowspan">
                                        <p> {group.areaName}</p>
                                        <div className="rowspan">
                                            {group.areaName}
                                        </div>
                                    </td> */}

        <div
            className="modal-body">
            <div ref={mainRef} className="p-6" >

                <div>

                    {
                        showDuplicate &&
                        <DuplicateRecordTable referralData={referralData} />
                    }

                    <div className="pdf-element" data-type="table">
                        <div className="d-flex justify-content-center mb-2">
                            <div className="text-center bg-white px-4 py-2 rounded">
                                <h3 className="header1">Divisional Report</h3>
                                <p>
                                    Practice-Wise Account Performance:
                                    <span className="text-primary">
                                        {formData?.division?.label ?? " All"}
                                    </span><br/>
                                   <span>Date Range : {`${formData._fromDate} - ${formData._toDate}`}</span>
                                </p>

                            </div>

                        </div>
                        <p style={{ fontSize: '12px' }} className="px-10 text-center">
                            Breakdown of accounts created and referred for each practice, both year-to-date ({getFinancialDateRange(formData.financialYearRange)})
                            and for the selected (
                            {formData._fromDate} -  {formData._toDate}
                            ), along with a yearly source-wise split (SMS,
                            WhatsApp, Others)
                        </p>
                    </div>
                    <div className="pdf-element" data-type="table">
                        <DivisionTableComponent referralData={referralData} formData={formData} />
                    </div>
                    <div className="pdf-element" data-type="table">
                        <CoachingInsights coachingInsight={coachingInsight} formData={formData} />
                    </div>
                    <div className="pdf-element" data-type="chart">
                        <GraphComponent name="Programme summary" tableName="Programme" chartData={programWise} total={total} />
                    </div>
                    <div className="pdf-element" data-type="chart">
                        <GraphComponent name="Practice summary" tableName="Practice" nameKey="clinicName" chartData={clinicWise} total={total}/>
                    </div>
                </div>
            </div>
        </div>
    </>
})
